import axios from 'axios';
import { baseUrl } from '../../config';

const token = () => localStorage.getItem('accessToken');
const headers = () => ({ Authorization: `Bearer ${token()}` });

export const listReports = (params = {}) =>
  axios.get(`${baseUrl}/monthly-reports/list`, { headers: headers(), params }).then(r => r.data);

export const createReport = (data) =>
  axios.post(`${baseUrl}/monthly-reports/create`, data, { headers: headers() }).then(r => r.data);

export const readReport = (id) =>
  axios.get(`${baseUrl}/monthly-reports/read/${id}`, { headers: headers() }).then(r => r.data);

export const updateReport = (id, data) =>
  axios.patch(`${baseUrl}/monthly-reports/update/${id}`, data, { headers: headers() }).then(r => r.data);

export const deleteReport = (id) =>
  axios.delete(`${baseUrl}/monthly-reports/delete/${id}`, { headers: headers() }).then(r => r.data);

export const uploadReportFile = (id, file, onProgress) => {
  const formData = new FormData();
  formData.append('report_file', file);
  return axios.post(`${baseUrl}/monthly-reports/upload-file/${id}`, formData, {
    headers: { ...headers(), 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (e) => onProgress && onProgress(Math.round((e.loaded * 100) / e.total)),
    timeout: 300000, // 5 min for large PDFs
  }).then(r => r.data);
};

export const filterCount = (payload) =>
  axios.post(`${baseUrl}/monthly-reports/filter-count`, payload, { headers: headers() }).then(r => r.data);

export const sendAll = (id, payload) =>
  axios.post(`${baseUrl}/monthly-reports/send-all/${id}`, payload, { headers: headers() }).then(r => r.data);

export const sendSelected = (id, user_ids) =>
  axios.post(`${baseUrl}/monthly-reports/send-selected/${id}`, { user_ids }, { headers: headers() }).then(r => r.data);

export const deleteReportFile = (id) =>
  axios.delete(`${baseUrl}/monthly-reports/delete-file/${id}`, { headers: headers() }).then(r => r.data);

// Members list for "send selected" table (reuses festival-campaign endpoint)
export const listMembers = (params = {}) =>
  axios.get(`${baseUrl}/festival-campaign/members`, { headers: headers(), params }).then(r => r.data);
